export default function TextEllipsis(props: any) {
  return <div className="text-ellipsis">{props.children}</div>;
}
